import { ErrorResponse } from '@/hooks/types/responses';
import { enqueueSnackbar, VariantType } from 'notistack';




export function handleSubmitError(
  error: ErrorResponse,
  setFieldError?: (field: string, errorMsg: string | string[]) => void,
  setCurrentStep?: (step: number | ((prev: number) => number)) => void,
  fieldStepMap?: Record<string, number>,
) {
  // eslint-disable-next-line no-console
  console.error('handleSubmitError', error);
  if (error?.response?.data?.message == 'Validation error') {
    if (setFieldError) {
      const fieldsWithErrors = Object.entries(
        error.response.data.extra?.fields || {},
      ).map(([field, errorMsg]) => {
        const processedErrorMsg = Array.isArray(errorMsg)
          ? [...errorMsg.map((subError) => ({ message: subError as string  } as { message: string }))]
          : errorMsg;
        setFieldError(field, processedErrorMsg as string | string[]);
        return field;
      });
      if (setCurrentStep && fieldStepMap) {
        const stepsWithErrors = Object.entries(fieldStepMap)
          .filter(([field, _step]) => {
            return fieldsWithErrors.includes(field);
          })
          .map(([_field, step]) => step)
          .sort((a, b) => a - b);
        const earliestStepWithError = stepsWithErrors[0];
        setCurrentStep((_currentStep: number) => earliestStepWithError);
      }
    }
    enqueueSnackbar('Corrija os campos indicados!', {
      variant: 'error' as VariantType,
    });
  } else if (error?.response?.data?.message) {
    enqueueSnackbar(error.response.data.message, {
      variant: 'error' as VariantType,
    });
  } else {
    enqueueSnackbar('Aconteceu algo de errado. Tente novamente!', {
      variant: 'error' as VariantType,
    });
  }
}
